import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Footer from "./components/Footer";
import Education from "./components/Education/index";
import Contact from "./components/Contact/Contact";
import Resume from "./components/Resume/Resume";
import Project from "./components/Projects/project";
// import SuggestionForm from "./components/SuggestionForm/suggestionForm";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";//hi 
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 2600);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/journey" element={<Education />} />
          <Route path="/project" element={<Project />}/> 
          <Route path="/resume" element={<Resume />} />
          <Route path="/contact" element={<Contact/>}/>
          {/* <Route path="/suggestion" element={<SuggestionForm/>} /> */}
          <Route path="*" element={<Navigate to="/"/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
